export enum EmailStatus {
  SENT = 'sent',
  FAILED = 'failed',
  PENDING = 'pending',
}

export interface EmailLog {
  id: number;
  recipient_email: string;
  recipient_name: string | null;
  subject: string;
  template_name: string;
  language: string;
  status: EmailStatus;
  sent_at: string | null;
  error_message: string | null;
  context: Record<string, any> | null;
  created_at: string;
}

export interface EmailTemplate {
  name: string;
  display_name: string;
  description: string;
  languages: string[];
  required_context: string[];
  optional_context: string[];
}

export interface SendEmailRequest {
  recipient_email: string;
  recipient_name?: string;
  template_name: string;
  subject?: string;
  language?: string;
  context?: Record<string, any>;
}

export interface SendBulkEmailRequest {
  recipient_emails: string[];
  template_name: string;
  subject?: string;
  language?: string;
  context?: Record<string, any>;
}

export interface SendEventEmailRequest {
  event_type: 'happy_new_year' | 'tournament_announcement' | 'match_reminder' | 'tournament_reminder' | 'club_newsletter';
  recipient_ids?: number[];
  template_name?: string;
  subject?: string;
  language?: string;
  context?: Record<string, any>;
  tournament_id?: number;
  match_id?: number;
  club_id?: number;
}

export interface EmailStats {
  total_sent: number;
  total_failed: number;
  success_rate: number;
  emails_by_template: Record<string, number>;
  emails_by_status: Record<string, number>;
  recent_activity: EmailLog[];
}

export interface EmailListResponse {
  emails: EmailLog[];
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

